export default function (uku) {
    this.message = "hello ukulelejs";
};


//////////////////
// WEBPACK FOOTER
// ./resources/js/example01.js
// module id = 5
// module chunks = 0